module.exports = __webpack_public_path__ + "static/IMG_3585.c3acbf9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/SongModal/IMG_3585.jpg
// module id = 485
// module chunks = 35783957827783